import { useSelector } from "react-redux";
import { createSelector } from "reselect";

const selectUserPermissions = createSelector(
  state => {
    const data = state.authme.data;
    const roles = data?.roles || [];

    // كل الصلاحيات من الأدوار + الصلاحيات المباشرة، ليطابق تحقّق الباك-إند
    // (hasPermissionTo يشمل الاثنين). سابقاً كانت الأدوار فقط تُقرأ.
    const rolePermissions = roles.flatMap(role => role.permessions || []);
    const directPermissions = data?.permissions || [];
    return [...rolePermissions, ...directPermissions];
  },
  permissions =>
    permissions.map(perm => perm.name)
  
);



function usePermissions() {
 const userPermissions = useSelector(selectUserPermissions);

//check for permissions 

 const hasPermission = (permission) => userPermissions.includes(permission);

 const checkPermissionAndThrow = (permission) => {
   if (!hasPermission(permission)) {
     return false;
   }
   else{
     return true;
   }
 };    


return { checkPermissionAndThrow , userPermissions }; 
    
}

export default usePermissions;  